export const cacheKeys = {
	cumulativeContentsDist: "cumulativeContentsDist",
	studypack: "studypack",
	practiceTest: "practiceTest",
	progress: "progress",
	examsCount: "examsCount",
	leaderboard: "leaderboard",
	userLeaderboard: "userLeaderboard",
	home: "home",
	itemsCount: "itemsCount",
	sessionConfig: "sessionConfig",
	sessionItems: "sessionItems",
	avatars: "avatars",
	activeAccessCodes: "activeAccessCodes",
	examDetails: "examDetails",
	exams: "exams",
	versionChecker: "versionChecker",
	categories: "categories",
	dashboard: "dashboard",
	insights: "insights",
	productDetails: "productDetails",
	productMetadata: "productMetadata",
	cache: "cache",
	migration: "migration",
	podcasts: "podcasts",
	answerEvent: "answerEvent",
	endSession: "endSession",
};
